export default __webpack_public_path__ + "static/media/meraki-design-sketches.60bd8f98.svg";